import React, { useState } from 'react';
import CommunicationsTimelinePage from './CommunicationsTimelinePage';
import CommunicationsComposerPage from './CommunicationsComposerPage';

/**
 * Dashboard Communications tab: timeline first, composer on "New Message".
 * The dashboard has no /communications routes, so views switch in place.
 */
const CommunicationsTab = () => {
  const [view, setView] = useState('timeline');

  if (view === 'composer') {
    return <CommunicationsComposerPage onBack={() => setView('timeline')} />;
  }
  return <CommunicationsTimelinePage onNewMessage={() => setView('composer')} />;
};

export default CommunicationsTab;
